import type { BusinessCategory, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/categories';

export function getCategories(query: BusinessCategory.SearchQuery) {
    return api.get<Pagination<BusinessCategory>>(rootPath, query);
}

export function getCategory(id: number) {
    return api.get<BusinessCategory.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postCategory(data: BusinessCategory.CreateRequest) {
    return api.post<BusinessCategory>(rootPath, data);
}

export function putCategory(id: number, data: BusinessCategory.UpdateRequest) {
    return api.put<BusinessCategory>(`${rootPath}/${id}`, data);
}

export function deleteCategory({ id }: BusinessCategory.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
